var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-tag',{class:[_vm.status, { inverse: _vm.inverse }],attrs:{"small":_vm.small,"disabled":true}},[_vm._v("\n    "+_vm._s(_vm._f("riskStatus")(_vm.status))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }